import { splitArrayByCondition } from "../../../utils/splitArrayByCondition";
import type { GTM } from "../GTMInterfaces";
import { hasCashbackFromPartner } from "./hasCashbackFromPartner";

type ServiceSplittedByCashbackFrom = [GTM.ServiceExtended[], GTM.ServiceExtended[]];

/** 
    @param {Array} GTM.ServiceExtended[] - services array
    @return {Array} ServiceSplittedByCashbackFrom - first element of array dont have the cashback from partner, the second have it
*/
export function splitServicesWithCashbackFromPartner(services: GTM.ServiceExtended[]): ServiceSplittedByCashbackFrom {
  return splitArrayByCondition<GTM.ServiceExtended>(services, hasCashbackFromPartner);
}
